import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/banner.jpg'
import _imports_1 from '../assets/phone.jpg'
import _imports_2 from '../assets/support2.png'
import _imports_3 from '../assets/support3.png'
import _imports_4 from '../assets/ewm1.jpg'
import _imports_5 from '../assets/play.png'
import _imports_6 from '../assets/movie.ogg'


const _withScopeId = n => (_pushScopeId("data-v-0a892638"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "banner",
  src: _imports_0
}
const _hoisted_2 = {
  class: "banner",
  src: _imports_1
}
const _hoisted_3 = { class: "problem" }
const _hoisted_4 = { class: "card-wrap" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c33 f32 title p-r" }, "常见问题", -1))
const _hoisted_6 = { class: "problem_list p-r" }
const _hoisted_7 = { class: "lists" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "lists lists_" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "service" }
const _hoisted_12 = { class: "card-wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c33 f32 title p-r" }, "技术服务", -1))
const _hoisted_14 = { class: "d-f j-a" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"d-f j-b technical\" data-v-0a892638><img src=\"" + _imports_2 + "\" alt=\"\" data-v-0a892638><div data-v-0a892638><div class=\"c00 f22\" data-v-0a892638>技术专员</div><div class=\"c66 f18\" data-v-0a892638>为您提供各种在线专业咨询，高效、便捷、无需等待 服务热线：18031089711</div></div></div><div class=\"d-f j-b technical technicals\" data-v-0a892638><img src=\"" + _imports_3 + "\" alt=\"\" data-v-0a892638><div data-v-0a892638><div class=\"c00 f22\" data-v-0a892638>扫码技术支持</div><div class=\"c66 f18\" data-v-0a892638>专业人员为您提供贴心服务，技术 交流，竭诚为您服务</div></div><img class=\"ewm\" src=\"" + _imports_4 + "\" alt=\"\" data-v-0a892638></div>", 2)
const _hoisted_17 = [
  _hoisted_15
]
const _hoisted_18 = { class: "service_ t-c d-f j-a" }
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"services\" data-v-0a892638><img src=\"" + _imports_2 + "\" alt=\"\" data-v-0a892638><div class=\"c00 f20 f-w\" data-v-0a892638>技术专员</div><div class=\"c66 f16\" data-v-0a892638> 为您提供各种在线专业咨询，高效、便捷、无需等待 </div><div class=\"c66 f16 time\" data-v-0a892638>服务时间：周一至周六 09:00-18:00</div><div class=\"c33 f20 f-w\" data-v-0a892638>服务热线：18031089711</div></div><div class=\"services\" data-v-0a892638><img src=\"" + _imports_3 + "\" alt=\"\" data-v-0a892638><div class=\"c00 f20 f-w\" data-v-0a892638>扫码获取技术支持</div><div class=\"c66 f16\" data-v-0a892638> 专业人员为您提供贴心服务，技术交流，竭诚为您服务 </div><img class=\"ewm\" src=\"" + _imports_4 + "\" alt=\"\" data-v-0a892638></div>", 2)
const _hoisted_21 = [
  _hoisted_19
]
const _hoisted_22 = {
  class: "video",
  style: {"display":"none"}
}
const _hoisted_23 = { class: "card-wrap" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cff f32 title p-r" }, "演示视频", -1))
const _hoisted_25 = { class: "p-r videos" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cff f14 p-a" }, "智测宝演示视频", -1))
const _hoisted_27 = {
  src: _imports_5,
  alt: ""
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("source", {
  src: _imports_6,
  type: "video/mp4"
}, null, -1))

import { ref, onMounted, watch, onUnmounted,nextTick } from "vue";
import {
    list,lastVersionReleases
} from "@/axios/index";
import router from "@/router";
import top from "./top.vue";
import bottom from "./bottom.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'support',
  setup(__props) {

const problem = ref([]);
const qqNumber = ref('38090539');
// const openQQ = async () => {

//     const qqChatUrl = `tencent://message/?uin=516078176&Site=www.xinxikaoshi.com&Menu=yes`;
//     window.location.href = qqChatUrl;
// };
const lists = async () => {
    const { data }: any = await list({});
    if (data.code == 200) {
        problem.value = data.data
    }
};
const video = ref(null);
const pro_index = ref(0);
const show = ref(1);
const videoPlaying = ref(false);
const screenWidth = ref(window.innerWidth);

const handleResize = () => {
    screenWidth.value = window.innerWidth;
};

const problems = (val) => {
    const newpage = router.resolve({
        path: '/details',  // 跳转的页面路由
        query: { // 要传的参数
          data: val.id
        }
      })
      window.open(newpage.href, '_blank') 
};
const togglePlay = () => {
    if (video.value.paused) {
        video.value.play();
        videoPlaying.value = true;
    } else {
        video.value.pause();
        videoPlaying.value = false;
    }
};

const releasess = ref();
const releasess_ = ref();
const lastVersionReleasess = async () => {
    const { data }: any = await lastVersionReleases({});
    if (data.code == 200) {
        releasess.value = data.data.url
        releasess_.value =data.data.url2
    };
};
onMounted(() => {
    lastVersionReleasess();
    lists();
    window.addEventListener('resize', handleResize);
    watch(videoPlaying, (newValue) => {
        if (newValue) {
            video.value.play();
        } else {
            video.value.pause();
        }
    });
    nextTick(() => {
      document.oncontextmenu = new Function("event.returnValue=false");
      document.onselectstart = new Function("event.returnValue=false");
      document.addEventListener("keydown", function (e) {
        if (e.key == "F12") {
          e.preventDefault(); // 如果按下键F12,阻止事件
        }
      });
    })
});
onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(top, {
      releasess: releasess.value,
      releasess_: releasess_.value
    }, null, 8, ["releasess", "releasess_"]),
    _withDirectives(_createElementVNode("img", _hoisted_1, null, 512), [
      [_vShow, screenWidth.value > 740]
    ]),
    _withDirectives(_createElementVNode("img", _hoisted_2, null, 512), [
      [_vShow, screenWidth.value < 740]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(problem.value, (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "c33 f16 ov",
                onClick: ($event: any) => (problems(item)),
                key: index
              }, "· " + _toDisplayString(item.question), 9, _hoisted_8)), [
                [_vShow, index % 2 == 0]
              ])
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(problem.value, (item, index) => {
              return _withDirectives((_openBlock(), _createElementBlock("div", {
                class: "c33 f16 ov",
                onClick: ($event: any) => (problems(item)),
                key: index
              }, "· " + _toDisplayString(item.question), 9, _hoisted_10)), [
                [_vShow, index % 2 != 0]
              ])
            }), 128))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("div", _hoisted_14, _hoisted_17, 512), [
          [_vShow, screenWidth.value > 740]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_18, _hoisted_21, 512), [
          [_vShow, screenWidth.value < 740]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("button", {
            class: "p-a",
            style: _normalizeStyle({
                        opacity: videoPlaying.value ? '0' : '1',
                    }),
            onClick: togglePlay
          }, [
            _withDirectives(_createElementVNode("img", _hoisted_27, null, 512), [
              [_vShow, !videoPlaying.value]
            ])
          ], 4),
          _createElementVNode("video", {
            ref_key: "video",
            ref: video,
            controls: ""
          }, [
            _hoisted_28,
            _createTextVNode(" Your browser does not support the video tag.s ")
          ], 512)
        ])
      ])
    ]),
    _createVNode(bottom, {
      releasess: releasess.value,
      releasess_: releasess_.value
    }, null, 8, ["releasess", "releasess_"])
  ]))
}
}

})